import { Events, Service, Severity, Watchdog } from "@timing71/common";
import { RaceControlMessage } from '@timing71/common/messages';
import { Client } from "./client.js";
import { getManifest, getState } from "./translate.js";

export class FIAWEC extends Service {

  constructor(...args) {
    super(...args);
    this._update = this._update.bind(this);
    this._persistedDataForRestoration = {};

    this.watchdog = new Watchdog(30000);

    this.watchdog.on('timeout', () => {
      this.emit(
        Events.SYSTEM_MESSAGE,
        {
          severity: Severity.WARNING,
          title: 'No data received',
          message: 'No data has been received from the upstream timing source for more than 30 seconds.',
          timeout: 30000,
          uuid: this.service.uuid
        }
      );
    });

    this.watchdog.on('dataReceived', () => {
      this.emit(Events.RETRACT_SYSTEM_MESSAGE, { uuid: this.service.uuid });
    });
  }

  start(connectionService) {
    this.client = new Client(
      connectionService,
      this._persistedDataForRestoration.sessionData,
      this._persistedDataForRestoration.bestSectors,
      this._persistedDataForRestoration.raceControlPrevTimestamp,
      this._persistedDataForRestoration.refData
    );

    this.client.on('update', this._update);

    this.client.on('connected', () => this.emitInfo(null, 'Connected to upstream data source'));
    this.client.on('error', (e) => this.emitWarning(null, `Error from upstream data source: ${e}`));
    this.client.on('disconnected', () => this.emitWarning(null, 'Disconnected from upstream data source'));

    this.client.on('race_control', (messages) => {
      this.watchdog.dataReceived();
      this.onStateChange({
        extraMessages: messages.map(
          m => new RaceControlMessage(m.text, m.dayTime).toCTDFormat()
        )
      })
    });

    this.client.on('session_change', this.onSessionChange);

    this.client.start();
    this.watchdog.start();
  }

  _update() {
    this.watchdog.dataReceived();

    this.onManifestChange(
      getManifest(this.client)
    );

    this.onStateChange(getState(this.client));
  }

  getTransientStateForSaving() {
    return {
      sessionData: this.client.sessionData,
      bestSectors: this.client.bestSectors,
      raceControlPrevTimestamp: this.client.raceControlPrevTimestamp,
      refData: this.client.refData
    }
  }

  restoreTransientState(state) {
    this._persistedDataForRestoration = state;
    // Force a search for the current session by deleting just the ID from the
    // persisted data
    delete this._persistedDataForRestoration.sessionData.id;
  }

  stop() {
    this.client?.stop();
    this.watchdog.stop();
  }
}

FIAWEC.regex = /fiawec.tv/;
